import React from "react";

import "../../styles/errors.scss";

class Error503 extends React.Component {
  render() {
    return (
      <div className="error-page">
        <h1>503 Error</h1>
        <div className="center-box">
          <p>
            <b>Service Temporarily Unavailable</b>
          </p>
          <p style={{ lineHeight: 2.06 }}>
            The server is temporarily unable to service your request due to
            maintenance downtime or capacity problems.
          </p>
          <p>Please try again later.</p>
        </div>
      </div>
    );
  }
}

export default Error503;
